import React from 'react';
import styled from 'styled-components';
import Button from './Button';
import { useNavigate } from 'react-router-dom';

/**
 * Component to display when a user tries to add more profiles than their plan allows
 * @param {Object} error - Error object from the API response
 * @param {Function} onClose - Function to call when the alert is closed
 */
const PlanLimitExceededMessage = ({ error, onClose }) => {
  const navigate = useNavigate();
  
  // Extract information from the error response
  const { message, currentCount, maxAllowed, plan } = error || {};
  
  return (
    <AlertContainer>
      <AlertHeader>
        <AlertTitle>Plan Limit Reached</AlertTitle>
        <CloseButton onClick={onClose}>&times;</CloseButton>
      </AlertHeader>
      <AlertBody>
        <p>{message || `You've reached the maximum number of baby profiles allowed for your ${plan || 'current'} plan.`}</p>
        
        <div className="mt-3">
          <p>
            <strong>Need to add more profiles?</strong> Please contact <a href="mailto:support@dozzy.au">support@dozzy.au</a> to upgrade your plan.
          </p>
        </div>
      </AlertBody>
    </AlertContainer>
  );
};

// Styled components for the alert
const AlertContainer = styled.div`
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  overflow: hidden;
`;

const AlertHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.25rem;
  background-color: rgba(255, 243, 205, 0.4);
  border-bottom: 1px solid #ffeeba;
`;

const AlertTitle = styled.h4`
  margin: 0;
  font-size: 1.1rem;
  color: #856404;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  color: #856404;
  cursor: pointer;
  padding: 0;
  opacity: 0.5;
  
  &:hover {
    opacity: 1;
  }
`;

const AlertBody = styled.div`
  padding: 1.25rem;
  
  p {
    margin-bottom: 1rem;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  a {
    color: #856404;
    font-weight: bold;
    text-decoration: underline;
    
    &:hover {
      color: #66500c;
    }
  }
`;

export default PlanLimitExceededMessage;
